import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  type ApplicationConfig,
} from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Router } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { TailwindThemeService } from '@backoffice-frontend/shared/ui-tailwind';
import {
  LocaleProvider,
  translocoProviders,
} from '@backoffice-frontend/shared/util-transloco';
import { EnvConfig } from '@clean-code/models/common';
import { authErrorInterceptor } from '@clean-code/shared/auth/util-auth';
import type { SplashScreenState } from '@clean-code/shared/common';
import { MatPaginationIntlService } from '@clean-code/shared/components/ui-mat-table';
import { SideNavService } from '@clean-code/shared/templates/ui-tailwind-full-width';
import { provideConfig } from '@clean-code/shared/util-config';
import { dateHttpInterceptor } from '@clean-code/shared/util-graphql';
import { provideCustomNativeDateAdapter } from '@clean-code/shared/util/util-date';
import {
  GlobalErrorHandlerService,
  errorInterceptorService,
} from '@clean-code/shared/util/util-error';
import {
  USER_LIMIT_SERVICE,
  UserLimitPersonalService,
} from '@clean-code/user-limit/domain';
import { RxState } from '@rx-angular/state';
import * as Sentry from '@sentry/angular-ivy';
import { provideToastr } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppModule } from './app.module';

export const appConfig: ApplicationConfig = {
  providers: [
    providers(),
    provideCustomNativeDateAdapter(),
    provideAnimationsAsync(),
    provideConfig(environment as EnvConfig),

    importProvidersFrom(AppModule),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([
        authErrorInterceptor,
        // graphqlErrorInterceptor,
        dateHttpInterceptor,
        errorInterceptorService,
      ]),
    ),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    // provideRouter(
    //   appRoutes,
    //   withComponentInputBinding(),
    //   withRouterConfig({ paramsInheritanceStrategy: 'always' })
    // ),
    provideToastr(),
    translocoProviders,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};

function providers() {
  return [
    RxState,
    LocaleProvider,
    TailwindThemeService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    ...(environment.enableSentry
      ? [
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
              showDialog: true,
            }),
          },
        ]
      : []),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginationIntlService,
    },
    {
      provide: USER_LIMIT_SERVICE,
      useClass: UserLimitPersonalService,
    },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false },
    },
    SideNavService,
    RxState<SplashScreenState>,
  ];
}
